import { gql } from '@apollo/client'

export const TRIAL_SOFTWARE_LICENSE = gql`
  query TrialSoftwareLicense($serialNumber: String!) {
    verifySoftwareLicense(serialNumber: $serialNumber)
  }
`
